import { Button, Checkbox, Col, Dropdown, Row } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CaretDownOutlined } from '@vindr/icons';

const CheckboxSelection = ({ options, value, size, suffixIcon, onChange, height }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const { t } = useTranslation('Vindoc');

  useEffect(() => {
    if (value?.length) {
      setSelectedItems([...value]);
    } else {
      setSelectedItems([]);
    }
  }, [value]);

  const onSelect = (selection) => {
    setSelectedItems([...selection]);
  };

  const CheckboxRender = () => {
    const groups = options
      .map((e, i) => (i % height === 0 ? options.slice(i, i + height) : null))
      .filter((e) => e);

    return (
      <Checkbox.Group
        onChange={onChange}
        value={selectedItems}
        className="checkbox-menu dd-shadow flex min-w-40 flex-col rounded-sm bg-background-light-5 dark:bg-background-dark-5 p-1"
      >
        <Row>
          {groups.map((group, i) => {
            return (
              <Col key={`checkbox-group-${i}`} span={Math.floor(24 / groups.length)}>
                {group.map((label, i) => {
                  return (
                    <Checkbox key={label} value={label} style={{ display: 'flex', margin: '0' }}>
                      {t(label)}
                    </Checkbox>
                  );
                })}
              </Col>
            );
          })}
        </Row>
        <Row>
          <Col sm={12}>
            <Button
              size="small"
              onClick={() => onSelect([])}
              style={{ marginTop: 10, width: '100%' }}
            >
              {t('Clear')}
            </Button>
          </Col>
          <Col sm={12}>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                onChange(selectedItems);
                setShowDropdown(false);
              }}
              style={{ marginTop: 10, width: '100%' }}
            >
              {t('Apply')}
            </Button>
          </Col>
        </Row>
      </Checkbox.Group>
    );
  };

  return (
    <Dropdown
      overlay={<CheckboxRender />}
      trigger={['click']}
      visible={showDropdown}
      onVisibleChange={(visible) => {
        if (!visible) {
          // set to previous value if current not apply
          setSelectedItems([...value]);
        }
        setShowDropdown(visible);
      }}
    >
      <Button
        size={size}
        style={{
          color: 'rgba(255, 255, 255, 0.3)',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color:
              selectedItems.length && !(selectedItems.length == 1 && selectedItems[0] == '*')
                ? '#fff'
                : 'rgba(255, 255, 255, 0.3)',
          }}
        >
          {selectedItems?.length && !(selectedItems.length == 1 && selectedItems[0] == '*')
            ? selectedItems.map((it) => t(it)).join(', ')
            : t('Select')}
        </span>
        {suffixIcon || <CaretDownOutlined style={{ color: 'rgba(255, 255, 255, 0.3)' }} />}
      </Button>
    </Dropdown>
  );
};

export default CheckboxSelection;

CheckboxSelection.propTypes = {
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  size: PropTypes.string,
  suffixIcon: PropTypes.element,
  onChange: PropTypes.func,
  height: PropTypes.number,
};

CheckboxSelection.defaultProps = {
  height: 3,
};
